import React, { FC } from 'react'
import Grid from '@material-ui/core/Grid'
import Container from '@material-ui/core/Container'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import { tagManagerHandler } from '../../utils'

const useStyles = makeStyles((theme) => ({
  row: {
    maxWidth: 1000,
    margin: 'auto',
    marginTop: theme.spacing(12),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      textAlign: 'left',
    },
  },
  row2: {
    maxWidth: 1000,
    margin: 'auto',
    marginTop: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(1),
      textAlign: 'left',
    },
  },
  pageTitle: {
    fontSize: '2.25rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '2rem',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.75rem',
    },
  },
}))

export const PrivacyPolicyPage: FC = () => {
  const classes = useStyles()
  const { t } = useTranslation()
  tagManagerHandler('PagePrivacyPolice')

  return (
    <>
      <Container>
        <Box className={classes.row}>
          <Grid item xs={12} container justify={'center'}>
            <Typography
              component="h1"
              variant={'h1'}
              align="left"
              color="textPrimary"
              className={classes.pageTitle}
            >
              {t('Privacy')}
            </Typography>
          </Grid>
        </Box>

        <Box className={classes.row2}>
          <Grid container spacing={2}>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H0') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P01') }} />
              </Typography>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P02') }} />
              </Typography>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P03') }} />
              </Typography>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P04') }} />
              </Typography>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P05') }} />
              </Typography>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H1') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P11') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H2') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P21') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P22') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H3') }} />
                </Typography>
              </Box>
              <Box mt={3} mb={3}>
                <Typography variant="h4" component="h4" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H3-1') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P31') }} />
              </Typography>
              <Box mt={3} mb={3}>
                <Typography variant="h4" component="h4" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H3-2') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P32') }} />
              </Typography>
              <Box mt={3} mb={3}>
                <Typography variant="h4" component="h4" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H3-3') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P33') }} />
              </Typography>
              <Box mt={3} mb={3}>
                <Typography variant="h4" component="h4" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H3-4') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P34') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H4') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P41') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H5') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P51') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H6') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P61') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H7') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P71') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H8') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P81') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H9') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P91') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H10') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P101') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H11') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-H11') }} />
              </Typography>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P111') }} />
              </Typography>
            </Grid>
            <Grid container item xs={12}>
              <Box mt={3} mb={3}>
                <Typography variant="h3" component="h3" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H12') }} />
                </Typography>
              </Box>
              <Box mt={3} mb={3}>
                <Typography variant="h4" component="h4" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H12-1') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P121') }} />
              </Typography>
              <Box mt={3} mb={3}>
                <Typography variant="h4" component="h4" gutterBottom>
                  <div dangerouslySetInnerHTML={{ __html: t('Privacy-H12-2') }} />
                </Typography>
              </Box>
              <Typography>
                <div dangerouslySetInnerHTML={{ __html: t('Privacy-P122') }} />
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </>
  )
}
